import { useState } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';

type Props = {
  value: string;
};

const CopyButton = ({ value }: Props) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    });
  };

  return (
    <IconButton onClick={handleCopy} size="small" aria-label="copy">
      {copied ? (
        <Tooltip title="Copied!" placement="top">
          <CheckIcon fontSize="small" color="success" />
        </Tooltip>
      ) : (
        <Tooltip title="Copy" placement="top">
          <ContentCopyIcon fontSize="small" color="action" sx={{ '&:hover': { color: 'primary.main' } }} />
        </Tooltip>
      )}
    </IconButton>
  );
};
export default CopyButton;
